"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSuggestionSubtitleItem = exports.StyledSuggestionSubtitle = exports.StyledSuggestionLineThrough = exports.StyledSuggestion = exports.StyledSuggestionNote = exports.StyledSuggestions = exports.StyledSuggestionWrapper = exports.StyledContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.StyledContainer = theme_1.styled.div `
  position: relative;
`;
exports.StyledSuggestionWrapper = theme_1.styled.div `
  ${({ theme }) => theme.common['box-shadow']};
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: ${({ isFocused }) => (isFocused ? 11 : 10)};
  padding: 12px 12px 12px 0;
  max-height: 216px;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : theme.common.radius; }};
`;
exports.StyledSuggestions = theme_1.styled.ul `
  position: relative;
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
  max-height: 192px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.neutral[50]};
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.neutral[20]};
  }
`;
exports.StyledSuggestionNote = theme_1.styled.div `
  ${theme_1.typography.caption1.regular}
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 10px 10px 5px 10px;
`;
exports.StyledSuggestion = theme_1.styled.button `
  ${theme_1.typography.regular18}
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 12px 16px;
  cursor: pointer;
  box-sizing: border-box;
  display: block;
  background: none;
  border: none;
  text-align: left;
  width: calc(100% - 8px);

  ${({ isSelected, theme }) => isSelected && `background: ${theme.colors.neutral[10]};`}

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[10]};
  }
`;
exports.StyledSuggestionLineThrough = theme_1.styled.div `
  ${({ liquidated }) => liquidated && 'text-decoration: line-through;'}
`;
exports.StyledSuggestionSubtitle = theme_1.styled.div `
  ${theme_1.typography.caption1.regular}
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledSuggestionSubtitleItem = theme_1.styled.div `
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 4px;

  &:last-child {
    margin-right: 0;
  }
`;
